import { withVariants, Video } from '@hvccc/component-library';

const styles = {
  'standard-content': Video,
};

export default withVariants(styles)(Video);
